module.exports = __webpack_public_path__ + "img/banner-dark.c8926ec8.png";